import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from "@mui/material";
import React from 'react'

const ModalWarningAdvisor = (props) => {
    const { handleClose, open } = props;

    return (
        <Dialog
            fullWidth
            maxWidth={"sm"}
            open={open}
            onClose={() => {
                handleClose();
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <DialogTitle style={{ backgroundColor: '#007BEF', color: 'white' }} >{'Warning!'}</DialogTitle>
            <DialogContent style={{ margin: "auto" }}>
                <Typography textAlign={'justify'}>{'Advisor seems to be not binding to this plan! '}</Typography>
                <Typography textAlign={'justify'}>{'Please logout and login again!'}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>I understand</Button>
            </DialogActions>
        </Dialog>)
}

export default ModalWarningAdvisor